import axios from 'axios';
import { api } from './client';
import type { LoginRequest, TokenResponse, User, BaseResponse } from '../types/auth';
import type { EmpresaAcessoItem } from '../contexts/EmpresaAtivaContext';

export interface TenantPaymentLinkResponse {
  link_pagamento: string;
  email_enviado: boolean;
  email_destino?: string | null;
  payment_id?: string | null;
}

export const authApi = {
  login: async (data: LoginRequest): Promise<TokenResponse> => {
    const response = await api.post<BaseResponse<TokenResponse>>('/auth/login', {
      email: data.email,
      senha: data.password,
    });
    return response.data.data;
  },

  me: async (): Promise<User> => {
    const response = await api.get<BaseResponse<User>>('/auth/me');
    return response.data.data;
  },

  refresh: async (refreshToken: string): Promise<TokenResponse> => {
    // Usa axios diretamente para evitar o interceptor que adiciona o access_token expirado
    const baseURL = api.defaults.baseURL;
    const response = await axios.post<BaseResponse<TokenResponse>>(
      `${baseURL}/auth/refresh`,
      {},
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      }
    );
    return response.data.data;
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('active_empresa_id');
  },

  uploadTenantLogo: async (file: File): Promise<{ logo_url: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post<BaseResponse<{ logo_url: string }>>('/auth/tenant/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  },

  empresasAcesso: async (empresaId?: string): Promise<{ active_empresa_id: string | null; empresas: EmpresaAcessoItem[] }> => {
    const response = await api.get<BaseResponse<{ active_empresa_id: string | null; empresas: EmpresaAcessoItem[] }>>('/auth/empresas-acesso', {
      params: empresaId ? { empresa_id: empresaId } : undefined,
    });
    return response.data.data;
  },

  reenviarLinkPagamento: async (): Promise<TenantPaymentLinkResponse> => {
    const response = await api.post<BaseResponse<TenantPaymentLinkResponse>>('/auth/tenant/payment/resend');
    return response.data.data;
  },
};
